import withStrings from './withStrings';

export default withStrings;
